import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Header from '../../../components/Header';
import { Main, MainContainer } from '../request/resume/RequestResume';
import { DateContainerInput, DateInput } from '../../../components/Header/Search/SearchStyles';
import { ButtonForm } from '../../../components/shared/formStyles.styled';
import { toastr } from 'react-redux-toastr';
import styled from 'styled-components';

const breadcrumb = [{ link: '', label: 'BI (v.beta)' }];

const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

function getPanelBaseUrl() {
  let baseUrl = process.env.REACT_APP_PANEL_URL;
  if (process.env.REACT_APP_ENV === 'prod') {
    baseUrl = process.env.REACT_APP_PANEL_URL_PROD;
  } else if (process.env.REACT_APP_ENV === 'stage') {
    baseUrl = process.env.REACT_APP_PANEL_URL_STAG || process.env.REACT_APP_PANEL_URL;
  }
  return baseUrl ? baseUrl.replace(/\/$/, '') : '';
}

/** Converte dd/mm/yyyy para yyyy-mm-dd */
function toYmd(value) {
  if (!value || value.length !== 10) return null;
  const parts = value.split('/');
  if (parts.length !== 3) return null;
  const [d, m, y] = parts;
  if (!d || !m || !y || y.length !== 4) return null;
  return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
}

const FormRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
  flex-wrap: wrap;

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 14px;
  }
`;

const Label = styled.label`
  font-size: 0.82rem;
  color: #64748b;
  min-width: 110px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding-top: 9px;

  @media (max-width: 800px) {
    min-width: 0;
    width: 100%;
    padding-top: 0;
    margin-bottom: 2px;

    &:empty {
      display: none;
    }
  }
`;

const FieldWrap = styled.div`
  width: 220px;
  max-width: 100%;

  @media (max-width: 800px) {
    width: 100%;
    max-width: 260px;
  }
`;

const ExtractButton = styled(ButtonForm)`
  min-width: 220px;

  @media (max-width: 800px) {
    min-width: 0;
    width: 100%;
    max-width: 260px;
    margin-top: 4px;
  }
`;

const FormCard = styled.div`
  max-width: 680px;
  width: 100%;
  padding: 22px 24px 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(21, 43, 78, 0.08);
  margin: 0 auto;
`;

const FormCardTitle = styled.h3`
  margin: 0 0 4px 0;
  color: #152b4e;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
`;

const FormCardSubtitle = styled.p`
  margin: 0 0 18px 0;
  color: #64748b;
  font-size: 0.84rem;
`;

const AvisoFiltroDatas = styled.p`
  font-weight: 600;
  font-style: normal;
  font-size: 0.82rem;
  color: #475569;
  margin: 2px 0 8px 0;
  flex: 1;
  line-height: 1.45;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 10px 12px;

  @media (max-width: 800px) {
    width: 100%;
    margin: 0;
  }
`;

const SpinnerBtn = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  vertical-align: middle;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

class ExtracaoDados extends PureComponent {
  state = {
    dataInicial: '',
    dataFinal: '',
    extraindo: false
  };

  handleDataInicialChange = (e) => {
    this.setState({ dataInicial: e.target.value });
  };

  handleDataFinalChange = (e) => {
    this.setState({ dataFinal: e.target.value });
  };

  handleExtrair = (e) => {
    e.preventDefault();
    const { dataInicial, dataFinal } = this.state;
    const dataInicialYmd = toYmd(dataInicial);
    const dataFinalYmd = toYmd(dataFinal);

    if (!dataInicialYmd || !dataFinalYmd) {
      toastr.warning('Datas inválidas', 'Preencha data inicial e data final no formato dd/mm/aaaa.');
      return;
    }

    if (dataFinalYmd < dataInicialYmd) {
      toastr.warning('Datas inválidas', 'A data final deve ser igual ou posterior à data inicial.');
      return;
    }

    const baseUrl = getPanelBaseUrl();
    if (!baseUrl) {
      toastr.error('Configuração', 'URL do panel não configurada (REACT_APP_PANEL_URL).');
      return;
    }

    const login = this.props.login || {};
    const token = login.user && login.user.token && login.user.token.access_token;
    if (!token) {
      toastr.error('Autenticação', 'Sessão inválida. Faça login novamente.');
      return;
    }

    this.setState({ extraindo: true });

    const url = `${baseUrl}/api/perfis-inquilinos`;
    const headers = { Authorization: `Bearer ${token}` };
    const data = {
      data_inicial: dataInicialYmd,
      data_final: dataFinalYmd,
      exportar: 1
    };

    axios.post(url, data, { headers, responseType: 'blob' })
      .then((response) => {
        const contentType = (response.headers['content-type'] || '').toLowerCase();
        if (contentType.indexOf('application/json') !== -1) {
          return response.data.text().then((text) => {
            const json = JSON.parse(text);
            if (json.queued) {
              toastr.success('Extração', json.message || 'O relatório será enviado para o seu e-mail em breve.');
              return;
            }
          });
        }
        // Não veio queued -> é o arquivo, baixa
        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const disposition = response.headers['content-disposition'];
        let filename = 'perfis_inquilinos.xlsx';
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const match = disposition.match(/filename="?([^";]+)"?/);
          if (match) filename = match[1];
        }
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        toastr.success('Extração', 'Arquivo baixado com sucesso.');
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          toastr.error('Autenticação', 'Token inválido ou expirado. Faça login no panel.');
        } else if (err.response && err.response.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const msg = JSON.parse(reader.result);
              toastr.error('Erro', msg.message || 'Falha na extração.');
            } catch (e) {
              toastr.error('Erro', 'Falha na extração.');
            }
          };
          reader.readAsText(err.response.data);
        } else {
          toastr.error('Erro', err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Falha na extração.');
        }
      })
      .finally(() => {
        this.setState({ extraindo: false });
      });
  };

  render() {
    const { dataInicial, dataFinal } = this.state;
    const login = this.props.login || {};
    const user = login.user || {};
    const usuario = user.usuario || {};
    const isMaster = usuario.master === true;

    if (!isMaster) {
      return <Redirect to="/intranet/dashboard" />;
    }

    return (
      <Main>
        <Header
          breadcrumb={breadcrumb}
          title="EXTRAÇÃO DE DADOS"
          actualLink="Extração de Dados"
        />
        <MainContainer>
          <FormCard>
            <FormCardTitle>Gerar Relatório de Extração</FormCardTitle>
            <FormCardSubtitle>
              Informe o período desejado para exportar os dados em Excel.
            </FormCardSubtitle>
            <form onSubmit={this.handleExtrair}>
              <FormRow>
                <Label>Data inicial</Label>
                <FieldWrap>
                  <DateContainerInput style={{ width: '100%' }}>
                    <DateInput
                      value={dataInicial}
                      onChange={this.handleDataInicialChange}
                      placeholder="dd/mm/aaaa"
                      mask={DATE_MASK}
                    />
                  </DateContainerInput>
                </FieldWrap>
              </FormRow>
              <FormRow>
                <Label>Data final</Label>
                <FieldWrap>
                  <DateContainerInput style={{ width: '100%' }}>
                    <DateInput
                      value={dataFinal}
                      onChange={this.handleDataFinalChange}
                      placeholder="dd/mm/aaaa"
                      mask={DATE_MASK}
                    />
                  </DateContainerInput>
                </FieldWrap>
              </FormRow>
              <FormRow>
                <Label />
                <AvisoFiltroDatas>
                  Para filtros superiores à 1 ano será enviado o arquivo para o email do usuário solicitante, assim que o arquivo for gerado.
                </AvisoFiltroDatas>
              </FormRow>
              <FormRow>
                <Label />
                <ExtractButton type="submit" disabled={this.state.extraindo}>
                  {this.state.extraindo ? <span>Gerando... <SpinnerBtn /></span> : 'Gerar Relatório (Excel)'}
                </ExtractButton>
              </FormRow>
            </form>
          </FormCard>
        </MainContainer>
      </Main>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login
});

export default connect(mapStateToProps)(ExtracaoDados);
